import { updateDoc, doc, getDoc } from "@firebase/firestore";
import { hideLoading, showLoading } from "./item-status-edit-slice";
import { editStatus } from "../item-status-list/item-status-list-slice";
import { showErrorSnackbar, showSuccessSnackbar } from "../../../shared/snackbar/snackbar-slice";

// export const getItemStatusDataService = async (dispatch, db, coll, id) => {
//     try {
//         const docRef = doc(db, coll, id);
//         const docSnap = await getDoc(docRef);
//         if (docSnap.exists()) {
//             return docSnap.data();
//         } else {
//             dispatch(showWarningSnackbar("This document no longer exists."));
//         }
//     } catch(e) {
//         console.error("ItemStatusEdit getItemStatusDataService error: ", e);
//     }
// };

export const editItemStatusService = async (dispatch, db, coll, id, formData) => {
    dispatch(showLoading());
    try {
        await updateDoc(doc(db, coll, id), formData);
        // Wait for the document to be updated
        await new Promise(resolve => setTimeout(resolve, 1000));
        const docSnap = await getDoc(doc(db, coll, id));
        const updatedData = docSnap.data();
        const data = {
            ...updatedData,
            id: id,
        };
        dispatch(editStatus(data));
        dispatch(showSuccessSnackbar('Updated successfully!'));
    } catch(e) {
        dispatch(showErrorSnackbar('Update failed! Please, try again.'));
        console.error("ItemStatusEdit editItemStatusService error: ", e);
    }
    dispatch(hideLoading());
}
